import React, { useEffect, useState } from "react";
import CrudResource from "./CrudResource";
import { api } from "../../lib/api";

export default function AdminProjects() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services?all=true").then((r) => setServices(r.data));
  }, []);

  const fields = [
    { key: "slug", label: "Slug" },
    { key: "title_tr", label: "Başlık (TR)" },
    { key: "title_en", label: "Başlık (EN)" },
    { key: "brand_name", label: "Marka" },
    { key: "category", label: "Kategori", type: "select",
      options: services.map((s) => ({ value: s.slug, label: s.title_tr })) },
    { key: "description_tr", label: "Açıklama (TR)", type: "textarea", span: 2 },
    { key: "description_en", label: "Açıklama (EN)", type: "textarea", span: 2 },
    { key: "cover_image", label: "Kapak Görseli", type: "media", accept: "image", span: 2 },
    { key: "video_url", label: "Video (YouTube / Vimeo / Dosya)", type: "media", accept: "video", span: 2 },
    { key: "gallery", label: "Galeri", type: "media-array", accept: "image", span: 2 },
    { key: "before_image", label: "Öncesi Görsel", type: "media", accept: "image", span: 2 },
    { key: "after_image", label: "Sonrası Görsel", type: "media", accept: "image", span: 2 },
    { key: "equipment", label: "Ekipmanlar (virgülle)", type: "array", span: 2 },
    { key: "services", label: "Servisler (slug'lar, virgülle)", type: "array", span: 2 },
    { key: "project_date", label: "Proje Tarihi (YYYY-MM-DD)" },
    { key: "status", label: "Durum", type: "select",
      options: [{ value: "published", label: "Yayında" }, { value: "draft", label: "Taslak" }] },
    { key: "featured", label: "Öne Çıkan", type: "checkbox" },
    { key: "order", label: "Sıra", type: "number" },
  ];
  const defaults = { slug: "", title_tr: "", title_en: "", brand_name: "", category: "", status: "published", featured: false, gallery: [], services: [], equipment: [], order: 100 };
  return <CrudResource resource="projects" publicPath="projects" title="Projeler" fields={fields} defaults={defaults} />;
}
